import { Country, IsoDateStr, Maybe, Site } from '@csp/csp-common-model';

export enum StudyDocumentsQueryFilterRoles {
  ALL = 'ALL',
  GSTM_AND_CRA = 'GSTM_AND_CRA',
}

export type StudyDocumentsQueryFilterCriteria = {
  country: Maybe<Country>;
  site: Maybe<Site>;
  folders: string[];
  fileName: string;
  roles: StudyDocumentsQueryFilterRoles | '';
};

export type StudyDocumentsQueryFilterdateRangeCriteria = {
  startDate: Maybe<IsoDateStr>;
  endDate: Maybe<IsoDateStr>;
};

export type StudyDocumentsQueryFilter = {
  pageSize: number;
  criteria: Partial<StudyDocumentsQueryFilterCriteria>;
  dateRangeCriteria: StudyDocumentsQueryFilterdateRangeCriteria;
  count: boolean;
};

export const EMPTY_STUDY_DOCUMENTS_QUERY_FILTER_CRITERIA: StudyDocumentsQueryFilterCriteria = {
  country: undefined,
  site: undefined,
  folders: [],
  fileName: '',
  roles: '',
};

export const EMPTY_STUDY_DOCUMENTS_QUERY_FILTER: StudyDocumentsQueryFilter = {
  pageSize: 40,
  count: true,
  criteria: EMPTY_STUDY_DOCUMENTS_QUERY_FILTER_CRITERIA,
  dateRangeCriteria: {
    endDate: undefined,
    startDate: undefined,
  },
};
